<template>
  <div>
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg  shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="w-full p-3 font-bold text-xl hover:bg-blue-400 mt-1 bg-blue-600 text-white rounded shadow"
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="flex justify-between p-8 text-sm border-t border-gray-300 bg-gray-100"
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>

    <div v-if="numero">
      <div class="bg-gray-100 grid justify-items-start">
      
      </div>
      <div class="">
         <div class="box-content mx-52 mt-10 font-bold">
        <p
          class="text-blue-400 uppercase shadow-xl rounded text-center mt-2 bg-white w-auto p-5"
        >
          maestro de mantenimiento de descuentos
        </p>
      </div>
        <modalDescuentos></modalDescuentos>
        
        <tablaDescuentos></tablaDescuentos>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import modalDescuentos from "../components/modales/modalDescuentos.vue";
import tablaDescuentos from "../components/Tablas/tablaDescuentos.vue";
export default {
  components: { modalDescuentos, tablaDescuentos},
  name: "descuentos",
  data() {
    return {
      falso:true,
      value:null
    };
  },
  computed: {
    ...mapState(["numero"]),
  },
  methods:{
    ...mapMutations(['value0','value1'])
  }
};
</script>
<style scoped>
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalDescuentos:target {
  opacity: 1;
  pointer-events: auto;
}
</style>